import { FC, ReactNode } from 'react';
import { Stack, StackProps, Typography } from '@mui/material';

export interface IEntityListItemCellProps extends Omit<StackProps, 'title'> {
	title?: ReactNode;
}

export const EntityListItemCell: FC<IEntityListItemCellProps> = ({ children, title, ...props }) => {
	return (
		<Stack direction="column" spacing={1} {...props}>
			{title ? (
				<Typography variant="body2" sx={{ color: 'grey.800', fontWeight: '400' }}>
					{title}
				</Typography>
			) : null}
			{children}
		</Stack>
	);
};
